import { QuickAddComponent } from '@theme/quick-add';

/**
 * Wires pi-upsell quick view buttons to the theme quick-add modal.
 * @param {ParentNode} [root]
 */
function bindPiUpsellQuickView(root = document) {
  root.querySelectorAll('[data-pi-upsell-quick-view]:not([data-pi-upsell-bound])').forEach((wrapper) => {
    wrapper.setAttribute('data-pi-upsell-bound', '');

    const quickAdd = wrapper.querySelector('quick-add-component');
    if (!(quickAdd instanceof QuickAddComponent)) return;

    wrapper.addEventListener('click', (event) => {
      const btn = event.target instanceof Element ? event.target.closest('[data-pi-upsell-quick-view-btn]') : null;
      if (!btn || !wrapper.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();
      quickAdd.handleClick(event);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => bindPiUpsellQuickView());
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) {
    bindPiUpsellQuickView(event.target);
  }
});
